import React, { useState, useEffect } from 'react';
import TopTabbar from "../components/partials/TopTabbar";
import Header from "../components/partials/Header";
import { Link } from "react-router-dom";
import Footer from "../components/partials/Footer";
import LoadingSpinner from '../utils/LoadingSpinner';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
    return (
        <div className="faq-item mb-3">
            <div
                className="faq-question p-3 rounded-lg shadow-sm cursor-pointer"
                onClick={onClick}
            >
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0 h5">{question}</h3>
                    <span className={`arrow-icon ${isOpen ? 'rotate-180' : ''}`}>
                        ▼
                    </span>
                </div>
            </div>
            {isOpen && (
                <div className="faq-answer p-3 bg-light border-top">
                    <p dangerouslySetInnerHTML={{ __html: answer.replace(/\n/g, '<br />') }}></p>
                </div>
            )}
        </div>
    );
};

const SupportPage = () => {
    const [openItems, setOpenItems] = useState({});
    const [isPageLoading, setIsPageLoading] = useState(true);

    const toggleItem = (categoryIndex, questionIndex) => {
        setOpenItems(prev => ({
            ...prev,
            [`${categoryIndex}-${questionIndex}`]: !prev[`${categoryIndex}-${questionIndex}`]
        }));
    };

    const faqCategories = [
        {
            category: "Transferts d'Argent",
            questions: [
                {
                    "question": "Comment envoyer de l'argent avec NTR Finance ?",
                    "answer": "Le processus est simple : <br />1) <b>Connectez-vous à votre compte,</b> <br />2) <b>Sélectionnez 'Transfert',</b> <br />3) <b>Choisissez le pays destinataire (Cameroun, Burkina Faso, Sénégal, Bénin ou Côte d'Ivoire),</b> <br />4) <b>Entrez les informations du bénéficiaire et le montant,</b> <br />5) <b>Effectuez le virement hors de l'application,</b> <br />6) <b>Après avoir effectué le virement Interac hors de l'application, revenez quelques instants plus tard dans l'application pour vérifier le statut de votre transfert.</b>"
                },
                {
                    "question": "Quels sont les délais de transfert ?",
                    "answer": "Avec NTR Finance, vos transferts sont traités rapidement : <br />1) <b>En 10 minutes pour les transferts vers les portefeuilles mobiles,</b> <br />2) <b>En quelques heures pour les retraits en espèces,</b> <br />3) <b>En 1-2 jours ouvrables pour les transferts bancaires.</b>"
                },
            ]
        },
        {
            category: "Frais et Limites",
            questions: [
                {
                    question: "Quels sont les frais de transfert ?",
                    answer: "Aucun frais. Le montant exact du transfert vous est toujours présenté avant la confirmation de votre transfert."
                },
                {
                    question: "Y a-t-il des limites de transfert ?",
                    answer: "Vous pouvez envoyer jusqu'à 5 000 CAD par transfert."
                }
            ]
        },
        {
            category: "Sécurité",
            questions: [
                {
                    question: "Comment NTR Finance protège mes informations ?",
                    answer: "NTR Finance utilise un cryptage de niveau bancaire et des protocoles de sécurité avancés. Nous sommes conformes aux réglementations canadiennes sur les services financiers et la protection des données."
                },
                {
                    "question": "Que faire en cas de problème ?",
                    "answer": "Notre service client est disponible 24/7. Contactez-nous par  <a href='https://wa.me/+15879894933' target='_blank'>WhatsApp</a>, par email à <a href='mailto:ntrfinancial@gmail.com' target='_blank'>ntrfinancial@gmail.com</a> ou par téléphone au <a href='tel:+15879894933' target='_blank'>+1 587-989-4933</a>."
                }
            ]
        },
        {
            category: "Modes de Paiement",
            questions: [
                {
                    question: "Quels moyens de paiement acceptez-vous ?",
                    answer: "Nous acceptons les virements bancaires, Interac, et les principaux portefeuilles électroniques canadiens."
                },
                {
                    "question": "Comment le bénéficiaire reçoit l'argent ?",
                    "answer": "Les options de réception incluent :\n- Le retrait en espèces dans nos agences au Cameroun à Douala.\n- Le dépôt sur compte bancaire (uniquement disponible au cameroun).\n- Les portefeuilles électroniques locaux."
                }
            ]
        }
    ];

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsPageLoading(false);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    if (isPageLoading) {
        return <LoadingSpinner isVisible={true} loadingText="Chargement du centre d'aide..." />;
    }

    return (
        <>
            <div className="d-flex flex-column vh-100">
                <div className="flex-grow-1 overflow-y-scroll">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        maxWidth: '800px',
                        margin: '0 auto'
                    }}>
                        <div className="verify-number-main">
                            <TopTabbar />
                            <Header />

                            <div className="verify-number-top">
                                <div className="container">
                                    <div className="home-top-content ">
                                        <div className="person-details" style={{ marginTop: '45px' }}>
                                            <p className="name">Centre d'Aide NTR Finance</p>
                                            <p className="balance mt-8">Trouvez rapidement des réponses à vos questions</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="verify-number-bottom" id="faq-main">
                                <div className="verify-number-bottom-wrap">
                                    <div className="verify-number-content">
                                        <div className="faq-full-sec">
                                            <div className="container py-4">
                                                <div className="faq-categories">
                                                    {faqCategories.map((category, categoryIndex) => (
                                                        <div key={categoryIndex} className="faq-category mb-4">
                                                            <h2 className="h4 mb-3">{category.category}</h2>
                                                            {category.questions.map((item, questionIndex) => (
                                                                <FAQItem
                                                                    key={questionIndex}
                                                                    question={item.question}
                                                                    answer={item.answer}
                                                                    isOpen={openItems[`${categoryIndex}-${questionIndex}`]}
                                                                    onClick={() => toggleItem(categoryIndex, questionIndex)}
                                                                />
                                                            ))}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="about-us-social-media" style={{ paddingBottom: '100px' }}>
                                            <h1 className="social-txt mt-16">
                                                <font style={{ verticalAlign: 'inherit' }}>
                                                    <font style={{ verticalAlign: 'inherit' }}>Contacter nous pour plus d'information</font>
                                                </font>
                                            </h1>

                                            <div className="about-us-icon-wrapper mt-12">
                                                <div className="social-detail-about">
                                                    <Link to="https://wa.me/+15879894933" target="_blank">
                                                        <div className="shape facebook-bg">
                                                            <img src="assets/svg/whatsapp-icon.svg" alt="WhatsApp" />
                                                        </div>
                                                    </Link>
                                                    <div>
                                                        <p className="about-social-txt">
                                                            <font style={{ verticalAlign: 'inherit' }}>
                                                                <font className="suport-social-txt" style={{ verticalAlign: 'inherit' }}>WhatsApp</font>
                                                            </font>
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="social-detail-about">
                                                    <Link to="mailto:ntrfinancial@gmail.com" target="_blank">
                                                        <div className="shape facebook-bg">
                                                            <img src="assets/svg/mail-icon.svg" alt="Gmail" />
                                                        </div>
                                                    </Link>
                                                    <div>
                                                        <p className="about-social-txt">
                                                            <font style={{ verticalAlign: 'inherit' }}>
                                                                <font className="suport-social-txt" style={{ verticalAlign: 'inherit' }}>Gmail</font>
                                                            </font>
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="social-detail-about">
                                                    <Link to="https://www.facebook.com/profile.php?id=61563752121174&mibextid=ZbWKwL" target="_blank">
                                                        <div className="shape twitter-bg">
                                                            <i className="fa-brands fa-facebook-f"></i>
                                                        </div>
                                                    </Link>
                                                    <div>
                                                        <p className="about-social-txt">
                                                            <font style={{ verticalAlign: 'inherit' }}>
                                                                <font className="suport-social-txt" style={{ verticalAlign: 'inherit' }}>Facebook</font>
                                                            </font>
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="social-detail-about">
                                                    <div className="shape youtube-bg">
                                                        <a href="tel:+15879894933" target="_blank">
                                                            <img src="assets/svg/sms-icon.svg" alt="Phone" />
                                                        </a>
                                                    </div>
                                                    <div>
                                                        <p className="about-social-txt">
                                                            <font style={{ verticalAlign: 'inherit' }}>
                                                                <font className="suport-social-txt" style={{ verticalAlign: 'inherit' }}>+1 587-989-4933</font>
                                                            </font>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SupportPage;